import { render, staticRenderFns } from "./DiskUsageGraph.vue?vue&type=template&id=b18c4d30&scoped=true&"
import script from "./DiskUsageGraph.vue?vue&type=script&lang=js&"
export * from "./DiskUsageGraph.vue?vue&type=script&lang=js&"
import style0 from "./DiskUsageGraph.vue?vue&type=style&index=0&id=b18c4d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18c4d30",
  null
  
)

export default component.exports